export default "__VITE_ASSET__DHc89b9Z__"